export enum AlertTypeEnum {
    SUCCESS,
    ERROR,
    INFO,
    WARNING
}
